import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  trigger,
  transition,
  animate,
  style,
  state,
} from '@angular/animations';
import { CdkDragStart } from '@angular/cdk/drag-drop';

import { Subscription } from 'rxjs';
import { leftMainMenu } from 'src/app/constants/leftMainMenuList';
import { leftSubMenu } from 'src/app/constants/leftSubMenuList';
import { ApiConstants } from 'src/app/constants/api-constants';
import {
  NotificationCIC,
  NotificationUFC,
  NotificationUSV,
} from '../notification';
import {
  DataService,
  ServicecallService,
  SharedService,
  ToggleSidebarService,
} from 'src/app/services';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { TimePeriod } from 'ngx-daterangepicker-material/daterangepicker.component';
import dayjs from 'dayjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.css'],
  animations: [
    trigger('slideInOut', [
      state(
        'false',
        style({
          width: '0',
          margin: '0',
        })
      ),
      state(
        'true',
        style({
          visibility: 'visible',
        })
      ),
      transition('false => true', animate('500ms ease-in')),
      transition('true => false', animate('500ms ease-out')),
    ]),
  ],
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  openNotificationBar: boolean = false;
  notificationList: any = [];
  masterWebNotification: any;
  token: any = ApiConstants.blobSasToken;
  disableMenu: boolean = false;
  tab: any;
  menuList: any[] = [...leftSubMenu.home];
  isSubShown: boolean = false;
  isMenuShown: boolean = true;
  leftMainMenu: any[] = [...leftMainMenu.menu];
  selectedMenuItem: any;
  selectedSiteProfile: string = '';
  isEditable: boolean = false;
  isChatBot = false;
  isdigitalTwin: boolean = false;
  public dateRange = new FormControl('8am - 8am');
  public dateRangeList: { name: string; value: string }[] = [
    {
      name:
        `${new Date(
          new Date().setDate(new Date().getDate() - 1)
        ).toLocaleDateString('en-GB')} 8am - ` +
        `${new Date().toLocaleDateString('en-GB')} 8am`,
      value: '8am - 8am',
    },
  ];
  hideSubMenu: boolean = false;

  private _subscription: Subscription | undefined;
  private _subOpen: boolean = false;
  private _dragging: boolean;
  private _dataServiceSubscription: Subscription;
  private _routerSubscription: Subscription;
  private _getToggleButtonClickSubscription: Subscription;
  private _tenantConfig: any;
  public datepickerForm: FormGroup;

  private _initializeForm(type: string = 'default') {
    this.datepickerForm = this._fb.group({
      thisdate: null,
    });
  }

  @ViewChild('mainlayout') mainlayout!: ElementRef;

  constructor(
    public router: Router,
    public service: ServicecallService,
    private _toggleButton: ToggleSidebarService,
    private _sharedData: SharedService,
    private _translate: TranslateService,
    private _dataSer: DataService,
    private _fb: FormBuilder,
    private _datePipe: DatePipe
  ) {
    this._dataServiceSubscription = this._dataSer.events.subscribe(
      (res: any) => {
        if (res.name === 'scrollTop') {
          // this._scrollToTop();
          if (res?.args[0]) {
            this.scrollToAlerts();
          } else {
            this._scrollToTop();
          }
        } else if (res.name === 'digitalTwinToggle') {
          this.isdigitalTwin = !this.isdigitalTwin;
        } else if (
          res.name === 'openNotification' ||
          res.name === 'newNotification'
        ) {
          this.openNotificationBar =
            res?.args[0] || res?.args[0] === false
              ? res?.args[0]
              : this.openNotificationBar;
          this.transformNotificationData();
        } else if (res.name === 'siteChanged' && res?.args?.[0]?._id) {
          this.selectedSiteProfile = JSON.parse(
            sessionStorage.getItem('selectedSiteProfile') || '{}'
          );
        }
      }
    );
    this._routerSubscription = router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const excludeUrl = ['login', 'signup', 'forgotPassword'];
        const urlSplit = event.url.split('/');
        if (urlSplit.length >= 2 && !excludeUrl.includes(urlSplit[1])) {
          this._onRouteChange(urlSplit);
        }
      }
    });
    this._getToggleButtonClickSubscription = this._toggleButton
      .getToggleButtonClick()
      .subscribe((val) => {
        this._onMenuToggleChange(val);
        window.dispatchEvent(new Event('resize'));
      });
    this._subOpen = true;
    this.isSubShown = false;
    this.isMenuShown = true;
    const urlSplits = this.router.url.split('/');
    const headerItems = urlSplits[1]
      ? urlSplits[1].includes('?')
        ? urlSplits[1].split('?')[0]
        : urlSplits[1]
      : 'null';
    this.selectedTab(headerItems, 'initial');
  }

  ngOnInit(): void {
    this._initializeForm();
    this._tenantConfig = this.service.getConfiguration('tenantGenericConfig')
      ? this.service.getConfiguration('tenantGenericConfig')
      : null;
    if (
      (this.router?.url?.split('/')?.[1] === 'vehicles' &&
      this._tenantConfig?.tenant === 'VOT') || (this.router?.url?.split('/')?.[1] === 'plants' && this._tenantConfig?.tenant === 'IOC' && this.service.getSiteId())
    ) {
      this.hideSubMenu = true;
    }
    this.leftMainMenu =
      this._tenantConfig?.tenant === 'VOT'
        ? [...leftMainMenu.validOpsMenu]
        : [...leftMainMenu.menu];
    this.masterWebNotification = this.service.getConfiguration(
      'webNotification'
    )
      ? this.service.getConfiguration('webNotification')
      : {};
    this.transformNotificationData();
    this._subscription = this._sharedData.subj$.subscribe((val) => {
      if (val) {
        this.disableMenu = true;
      } else {
        this.disableMenu = false;
      }
    });

    this.setDefaultDateTimeRange();
    this.saveTime();
    this._onRouteChange(this.router.url.split('/'));
  }

  setDefaultDateTimeRange() {
    this._initializeForm();
    this._tenantConfig = this.service.getConfiguration('tenantGenericConfig')
      ? this.service.getConfiguration('tenantGenericConfig')
      : null;
    const defaultStartDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      0,
      0,
      0,
      999
    );
    let startDate: Date;
    let endDate: Date;

    if (this._tenantConfig?.defaultYesterday) {
      ({ startDate, endDate } = this.service.getConfigStartAndEndDate(
        this._tenantConfig.defaultTimeRange
      ));
    } else if (this._tenantConfig.defaultTimeRange >= 1) {
      ({ startDate, endDate } = this.service.calculateDateRange(
        this._tenantConfig.defaultTimeRange
      ));
    } else {
      startDate = defaultStartDate;
      endDate = new Date();
    }
    if(this.service.getDateState('global')) {
      startDate = this.service.getDateState('global')?.date?.startDate;
      endDate = (this.service.getDateState('global')?.range === 'Custom' || this.service.getDateState('global')?.range === 'Yesterday') ? this.service.getDateState('global')?.date?.endDate : new Date();
    }

    this.datepickerForm.setValue({
      thisdate: { startDate, endDate },
    });
    const selectedRange = this.service.getDateState('global')?.range ?? (this._tenantConfig?.defaultYesterday ? 'Yesterday' : 'Today');
    this.service.setRangeSelected(selectedRange);
    this.service.setDateState('global',selectedRange,{startDate : new Date(startDate), endDate: new Date(endDate)});
    this.service.setVehicleDateRange({startDate : new Date(startDate), endDate: new Date(endDate)});
    this._dataSer.broadcast(
      'dateTimeRangeApplied',
      {
        startDate: this._datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
        endDate: this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      },
      {
        rangeSelected: this._tenantConfig?.defaultYesterday
          ? 'Yesterday'
          : 'Today',
      }
    );
  }

  saveTime(data?: any) {
    if (data) {
      let dateRange: TimePeriod = data?.dates;
      const offsetTime = new Date().getTimezoneOffset() * 60 * 1000;
      const startDate =
        this._getTimestampInMillisecond(dateRange?.[0]?.toDate()) + offsetTime;
      const endDate =
        this._getTimestampInMillisecond(dateRange?.[1]?.toDate()) + offsetTime;
      this.service.setRangeSelected(data?.label);
      this.service.setDateState('global',data?.label,{startDate : new Date(startDate), endDate: new Date(endDate)});
      this.service.setVehicleDateRange({startDate : new Date(startDate), endDate: new Date(endDate)});
      this._dataSer.broadcast(
        'dateTimeRangeApplied',
        {
          startDate: this._datePipe.transform(
            startDate,
            'yyyy-MM-ddTHH:mm:ssZZ'
          ),
          endDate: this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
        },
        { rangeSelected: data?.label }
      );
    } else {
      const defaultStartDate = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate(),
        0,
        0,
        0,
        999
      );
      let startDate: Date;
      let endDate: Date;

      if (this._tenantConfig?.defaultYesterday) {
        ({ startDate, endDate } = this.service.getConfigStartAndEndDate(
          this._tenantConfig.defaultTimeRange
        ));
      } else if (this._tenantConfig.defaultTimeRange >= 1) {
        ({ startDate, endDate } = this.service.calculateDateRange(
          this._tenantConfig.defaultTimeRange
        ));
      } else {
        startDate = defaultStartDate;
        endDate = new Date();
      }
      if(this.service.getDateState('global')) {
        startDate = this.service.getDateState('global')?.date?.startDate;
        endDate = (this.service.getDateState('global')?.range === 'Custom' || this.service.getDateState('global')?.range === 'Yesterday') ? this.service.getDateState('global')?.date?.endDate : new Date();
      }
      const selectedRange = this.service.getDateState('global')?.range ?? (this._tenantConfig?.defaultYesterday ? 'Yesterday' : 'Today');
      this.service.setRangeSelected(selectedRange);
      this.service.setDateState('global',selectedRange,{startDate : new Date(startDate), endDate: new Date(endDate)});
      this.service.setVehicleDateRange({startDate : new Date(startDate), endDate: new Date(endDate)});
      this._dataSer.broadcast(
        'dateTimeRangeApplied',
        {
          startDate: this._datePipe.transform(
            startDate,
            'yyyy-MM-ddTHH:mm:ssZZ'
          ),
          endDate: this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
        },
        {
          rangeSelected: this._tenantConfig?.defaultYesterday
            ? 'Yesterday'
            : 'Today',
        }
      );
    }
  }

  private _getTimestampInMillisecond(date: Date): number {
    return date ? new Date(date)?.getTime() : 0;
  }

  transformNotificationData() {
    this.notificationList = JSON.parse(
      sessionStorage.getItem('masterNotificationList')
    );
    if (this._tenantConfig?.tenant === 'UFC') {
      this.notificationList = NotificationUFC;
    } else if (this._tenantConfig?.tenant === 'USV') {
      this.notificationList = NotificationUSV;
    } else {
      this.notificationList = NotificationCIC;
    }

    this.notificationList?.map(
      (item: any) =>
        (item.convertedTime = this.service.getLastSeenFormat(
          new Date(item.sourceTime)
        ))
    );
  }

  clearNotification() {
    this.notificationList = [];
    sessionStorage.setItem(
      'masterNotificationList',
      JSON.stringify(this.notificationList)
    );
    this._dataSer.broadcast('clearNotification');
  }

  setToastrStyle(type: string, returnType: string) {
    if (this.masterWebNotification?.[type]) {
      let response = this.masterWebNotification[type]?.[returnType];
      returnType === 'notificationUrl'
        ? (response = response + this.token)
        : '';
      return response;
    } else {
      return returnType === 'notificationUrl'
        ? 'assets/images/info-icon-yellow.svg'
        : '#5B8EC4';
    }
  }

  appClickOutside() {
    if (this.openNotificationBar) {
      this.openNotificationBar = !this.openNotificationBar;
      this._dataSer.broadcast(
        'notificationOutsideClick',
        this.openNotificationBar
      );
    }
  }
  /**
   * Scrolls to top ( Dev-Tools )
   */
  scrollToTop() {
    if (this.mainlayout && this.mainlayout.nativeElement) {
      this.mainlayout.nativeElement.scrollTop = 0;
    }
  }

  /**
   * Scrolls to alerts ( Entity profile )
   */
  scrollToAlerts() {
    const alertElement = document.getElementById('alert');
    if (alertElement) {
      alertElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  selectedTab(tab: string, loadType: string = 'other', type?: any) {
    this.service.clearDateState();
    this.service.setVehicleDateRange(null);
    if (tab === 'home') {
      this.setDefaultDateTimeRange();
    }
    if ((tab === 'vehicles' && this._tenantConfig?.tenant === 'VOT') || (tab === 'plants' && this._tenantConfig?.tenant === 'IOC' && this.service.getSiteId())) {
      this.hideSubMenu = true;
    } else {
      this.hideSubMenu = false;
    }
    this.menuList = [];
    this.tab = this.leftMainMenu.find((data) => data.name === tab);
    this.menuList = [...leftSubMenu[this.tab?.name]];
    this.isSubShown = this.menuList.length ? true : false;
    this._subOpen = this.menuList.length ? true : false;
    const urlParsed = this.router.url.slice(1);
    const checkSubMenu = this.menuList.findIndex(
      (item: any) => item.nav === urlParsed
    );
    this.isSubShown
      ? this.redirectTo(
          checkSubMenu > -1 && type !== 'crumb' ? checkSubMenu : 0,
          loadType
        )
      : this.router.navigate([this.tab.nav]);
  }

  toggleShow() {
    this.isSubShown = false;
    window.dispatchEvent(new Event('resize'));
  }

  redirectTo(index: number, loadType: string = 'other') {
    this.menuList.map((v) => (v.isActive = false));
    this.menuList[index].isActive = true;
    const navUrl = this.router.url.split('/');
    // direct redirection to profile
    if (
      navUrl?.length === 4 &&
      loadType === 'initial' &&
      this.menuList[index]?.nav?.includes(navUrl?.[1]) &&
      navUrl?.includes('profile')
    ) {
      this.isSubShown = false;
      this.router.navigate([this.router.url]);
    } else this.router.navigate([this.menuList[index].nav]);
  }

  onWidgetEdit() {
    this.isEditable = true;
    this._dataSer.broadcast('onWidgetEdit');
  }

  onWidgetSave(type: string) {
    this.isEditable = false;
    this._dataSer.broadcast('onWidgetSave', type);
  }

  botAction(event: any) {
    if (event.type === 'close') {
      this.isChatBot = false;
    }
  }

  handleDragStart(event: CdkDragStart): void {
    this._dragging = true;
  }

  chatOpen() {
    if (this._dragging) {
      this._dragging = false;
      return;
    }
    this.isChatBot = !this.isChatBot;
  }

  // broadcast dateTime picker selection data
  // saveTime(datePickerData: TimePeriod) {
  //   this.dataSer.broadcast('onDatePickerChange', datePickerData);
  // }

  // rangeSelected(range: object) {
  //   this.dataSer.broadcast('onDateRangeChange', range);
  // }

  navigateTo() {
    this._dataSer.broadcast('digitalTwinToggle');
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._routerSubscription?.unsubscribe();
    this._getToggleButtonClickSubscription?.unsubscribe();
    if (this._dataServiceSubscription) {
      this._dataServiceSubscription.unsubscribe();
    }
  }
  /**
   * Scrolls to top
   */
  private _scrollToTop() {
    if (this.mainlayout && this.mainlayout.nativeElement) {
      this.mainlayout.nativeElement.scrollTop = 0;
    }
  }

  private _onRouteChange(urlSplit: any) {
    const headerItem = urlSplit[1]
      ? urlSplit[1].includes('?')
        ? urlSplit[1].split('?')[0]
        : urlSplit[1]
      : 'null';
    this.tab = this.leftMainMenu.find((data) => data.name === headerItem);
    this.menuList = [...leftSubMenu[this.tab.name]];
    this.selectedMenuItem = {
      title: this._translate.instant(this.tab?.code),
      crumb: [this._translate.instant(this.tab?.code)],
    };
    const selected = this.menuList.find((item: any) => {
      if (this.service?.rbacManagement(item?.privilege) && item?.isActive) {
        return item;
      }
    })?.name;
    if (selected) {
      const selectedPage =
        ((selected === 'Enrolled' && this.router.url?.includes('assets')) ||
          (selected === 'Enrolled Vehicles' &&
            this.router.url?.includes('vehicles'))) &&
        this.service.getConfiguration('tenantGenericConfig')?.twinLabel
          ? this.service.getConfiguration('tenantGenericConfig')?.twinLabel
          : selected;
      this.selectedMenuItem.crumb.push(selectedPage);
    }
    const redictEndpoint = [
      'users',
      'plants',
      'vehicles',
      'events',
      'wiki',
      'assets',
    ];
    if (redictEndpoint.includes(urlSplit[1])) {
      if (selected && urlSplit.includes('profile')) {
        this.selectedMenuItem.crumb.push('Profile');
      } else if (!selected && urlSplit.includes('profile')) {
        this.selectedMenuItem.crumb.push(this.menuList[0]?.name, 'Profile');
      } else if (!selected && urlSplit.includes('alerts')) {
        this.selectedMenuItem.crumb.push(this.menuList[0]?.name);
      } else if (selected && urlSplit.includes('view')) {
        this.selectedMenuItem.crumb.push('View');
      }
    }
    this.selectedSiteProfile = JSON.parse(
      sessionStorage.getItem('selectedSiteProfile') || '{}'
    );
  }

  private _onMenuToggleChange(val: any) {
    // if (val === 'sub' && this._subOpen && !this.isSubShown && this.isMenuShown) {
    //   this._subOpen = false;
    // } else if (this._subOpen && this.isSubShown && this.isMenuShown) {
    //   this.isSubShown = false;
    //   this._subOpen = false;
    // } else if (!this._subOpen && !this.isSubShown && this.isMenuShown) {
    //   this.isMenuShown = false;
    // } else if (!this._subOpen && !this.isSubShown && !this.isMenuShown) {
    //   this.isMenuShown = true;
    //   this._subOpen = true;
    // }
    const url = this.router.url.split('/');
    const page = url[1]
      ? url[1].includes('?')
        ? url[1].split('?')[0]
        : url[1]
      : 'null';
    if (
      val === 'sub' &&
      this._subOpen &&
      !this.isSubShown &&
      this.isMenuShown
    ) {
      this._subOpen = false;
    } else if (this._subOpen && !this.isSubShown && this.isMenuShown) {
      this.isSubShown = true;
      this.selectedTab(page);
    } else if (this._subOpen && this.isSubShown && this.isMenuShown) {
      this.isSubShown = false;
      this._subOpen = false;
    } else if (!this._subOpen && !this.isSubShown && this.isMenuShown) {
      this.isMenuShown = false;
    } else if (!this._subOpen && !this.isSubShown && !this.isMenuShown) {
      this.isMenuShown = true;
      this._subOpen = true;
    }
  }

  getAnalyticsLabel(route: string) {
    const nav = route?.split('/')?.[1] ;
    return this.service?.getConfiguration('analyticsUseCases')?.analyticsLabel?.[nav];
  }
}
